import React from 'react';
import { AlertTriangle } from 'lucide-react';
import ModalOverlay from '../ui/ModalOverlay';
import { NEUTRAL_COLORS, SYSTEM_COLORS } from '../../constants/brandPalette';

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Delete Item',
  description,
}) => (
  <ModalOverlay isOpen={isOpen} onClose={onClose} zIndex={60}>
    <div
      className="w-full max-w-sm rounded-2xl p-6 shadow-lg mx-4"
      style={{ backgroundColor: SYSTEM_COLORS.shellSurface }}
    >
      <div className="flex flex-col items-center text-center gap-3 mb-5">
        <div
          className="flex items-center justify-center w-12 h-12 rounded-full"
          style={{ backgroundColor: '#fee2e2' }}
        >
          <AlertTriangle className="w-6 h-6" style={{ color: SYSTEM_COLORS.danger }} />
        </div>
        <div>
          <h3 className="text-base font-semibold" style={{ color: NEUTRAL_COLORS.black }}>
            {title}
          </h3>
          {description && (
            <p className="text-sm mt-1" style={{ color: SYSTEM_COLORS.textMuted }}>
              {description}
            </p>
          )}
        </div>
      </div>

      <div className="flex gap-3">
        <button
          onClick={onClose}
          className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold border hover:opacity-70 transition-opacity"
          style={{
            borderColor: SYSTEM_COLORS.border,
            color: SYSTEM_COLORS.textMuted,
            backgroundColor: SYSTEM_COLORS.shellSurface,
          }}
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold hover:opacity-90 transition-opacity"
          style={{ backgroundColor: SYSTEM_COLORS.danger, color: '#fff' }}
        >
          Delete
        </button>
      </div>
    </div>
  </ModalOverlay>
);

export default ConfirmDeleteModal;
